import axios from "axios";
import { getAuthToken } from "./cookieUtils";
import { getAuthHeaders } from "./authUtils";

// Function to get all clients
export const getClientList = async (clientId = null, user = null, params = {}) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const authHeaders = await getAuthHeaders(clientId, user);
  try {
    const url = `${baseURL}/clients`;

    // Build query parameters
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.status) queryParams.append('status', params.status);
    if (params.industry) queryParams.append('industry', params.industry);
    if (params.location) queryParams.append('location', params.location);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.skip) queryParams.append('skip', params.skip);
    if (params.sort_by) queryParams.append('sort_by', params.sort_by);
    if (params.sort_order) queryParams.append('sort_order', params.sort_order);

    const fullUrl = queryParams.toString() ? `${url}?${queryParams.toString()}` : url;

    const response = await axios.get(fullUrl, {
      headers: authHeaders,
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get client by ID
export const getClientById = async (clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to create client
export const createClient = async (clientData) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients`;

    const response = await axios.post(url, clientData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to update client
export const updateClient = async (clientId, clientData) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}`;

    const response = await axios.put(url, clientData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to delete client
export const deleteClient = async (clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}`;

    const response = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get current client (for authenticated user)
export const getCurrentClient = async () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/current`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to switch client
export const switchClient = async (clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/switch`;

    const response = await axios.post(url, {}, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get client statistics
export const getClientStats = async (clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/statistics`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get client permissions
export const getClientPermissions = async (clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/permissions`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to update client permissions
export const updateClientPermissions = async (clientId, permissions) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/permissions`;

    const response = await axios.put(url, permissions, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// NEW FUNCTIONS BASED ON CLIENT MANAGEMENT DOCUMENTATION

// Function to search clients
export const searchClients = async (query) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/search?q=${encodeURIComponent(query)}`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Search clients response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get client statistics (admin dashboard)
export const getClientStatistics = async () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/statistics`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Client statistics response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to update client status
export const updateClientStatus = async (clientId, statusData) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/status`;

    const response = await axios.put(url, statusData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Update client status response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to update client preferences
export const updateClientPreferences = async (clientId, preferencesData) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/preferences`;

    const response = await axios.put(url, preferencesData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Update client preferences response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get client preferences
export const getClientPreferences = async (clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/preferences`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Get client preferences response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to update client openings
export const updateClientOpenings = async (clientId, openingsData) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/openings`;

    const response = await axios.put(url, openingsData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Update client openings response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get client openings
export const getClientOpenings = async (clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/openings`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Get client openings response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get client users
export const getClientUsers = async (clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/users`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Get client users response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to add client user
export const addClientUser = async (clientId, userData) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/users`;

    const response = await axios.post(url, userData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Add client user response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to create client admin
export const createClientAdmin = async (clientId, userData) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/users/admin`;

    const response = await axios.post(url, userData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Create client admin response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to create client employee
export const createClientEmployee = async (clientId, userData) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/users/employee`;

    const response = await axios.post(url, userData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Create client employee response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to update client user
export const updateClientUser = async (clientId, userId, userData) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/users/${userId}`;

    const response = await axios.put(url, userData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Update client user response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to deactivate client user
export const removeClientUser = async (clientId, userId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/users/${userId}`;

    const response = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Remove client user response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get client admins
export const getClientAdmins = async (clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/users/admins`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Get client admins response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get client employees
export const getClientEmployees = async (clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/clients/${clientId}/users/employees`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Get client employees response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get client dashboard data
export const getClientDashboard = async (clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/client-dashboard/${clientId}/dashboard`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Get client dashboard response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get client pipeline overview
export const getClientPipeline = async (clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/client-dashboard/${clientId}/pipeline`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Get client pipeline response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get client evaluation analytics
export const getClientEvaluationAnalytics = async (clientId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/client-dashboard/${clientId}/evaluation_analytics`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Get client evaluation analytics response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

